import React from "react";
import ErrorVertical from "../../Error/Vertical";

const Screen40 = () => {
    return <ErrorVertical />;
};

export default Screen40;
